<div id="captchaJuncture" class="container">
    <div class="row" *ngIf="!this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']">
        <div class="col-12 p-0">
            <div class="component-header __indicator">
                <h3 class="label m-0">{{ 'junctures.captcha.header' | translate }}</h3>
            </div>
        </div>
    </div>

    <div class="row justify-content-md-center mb-4 mt-5" *ngIf="!this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']">
        <div class="col-sm-10 col-md-8 mb-1 text-center">
            <img *ngIf='this.captchaPath' [src]="this.captchaPath" alt="captcha image" title="captcha image">
            <fa-icon *ngIf='!this.captchaPath' class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
        </div>
        <div class="col-sm-10 col-md-8">
            <div class="captcha-container mt-1">
                <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.captcha.placeholder' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
                <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">Ok</button>
                <button *ngIf='this.captchaPath' (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
            </div>
          <div class="feedback invalid-feedback" *ngIf="errorMessage">{{ errorMessage }}</div>
        </div>
    </div>

    <div class="row feedback-module" *ngIf="this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']" (click)="feedbackClick()">
        <div class="d-flex p-0">
            <a class="w-100">
                <fa-icon class="text-center ms-3 me-3" [icon]="faSpellCheck"></fa-icon>
                <div class="text">
                    <span class="top">{{ 'junctures.captcha.header' | translate }}</span><br>
                    <span class="bottom">{{ 'junctures.captcha.status' | translate }}</span>
                </div>
            </a>
        </div>
    </div>
</div>
